import { create } from 'zustand';
import { createSelectors, StoreName, withDevtools } from 'store/config';
import {
  createInitialProjectState,
  mergeProjectPayload,
  patchProjectMetadata,
} from './model';
import { createProjectLoadingActions } from './loadingActions';
import { createInitialProjectDataLoading } from './loadingModel';
import { createProjectSelectionActions } from './selectionActions';
import type { ProjectStore } from './types';

const useProjectStoreBase = create<ProjectStore>()(
  withDevtools(
    (set, get) => ({
      data: {
        project: createInitialProjectState(),
      },
      loading: createInitialProjectDataLoading(),

      actions: {
        setProject: (payload) =>
          set((state) => ({
            data: {
              project: mergeProjectPayload(payload, state.data.project),
            },
          })),

        patchMetadata: (project) =>
          set((state) => {
            const patched = patchProjectMetadata(state.data.project, project);
            return patched === state.data.project
              ? state
              : { data: { project: patched } };
          }),

        reset: () =>
          set({
            data: {
              project: createInitialProjectState(),
            },
            loading: createInitialProjectDataLoading(),
          }),

        ...createProjectSelectionActions(
          () => get().actions,
          () => get().data.project._id
        ),

        ...createProjectLoadingActions(set, () => get().loading),
      },
    }),
    StoreName.Project
  )
);

export const useProjectStore = createSelectors(useProjectStoreBase);

export const getProjectStoreState = (): ProjectStore =>
  useProjectStore.getState();
